module.exports = __webpack_public_path__ + "static/img/img2.d59ef419.png";